import { FlipHorizontal2, RotateCcw } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { EYEBROW, FOCUS_RING } from '../constants';
import { SliderRow } from '../controls';

export const BG_ADJUST_KEYS = ['brightness', 'contrast', 'saturation', 'blur', 'flip_h'];

export const hasBackgroundAdjust = (bg) =>
  Boolean(
    bg &&
      ((bg.brightness ?? 1) !== 1 || (bg.contrast ?? 1) !== 1 || (bg.saturation ?? 1) !== 1 || bg.blur || bg.flip_h)
  );

const pct = (v) => `${Math.round(v * 100)}%`;

/** Brightness / contrast / saturation / blur / mirror for the template artwork (invitation.background). */
export const BackgroundAdjustControls = ({ background, onChange }) => {
  const bg = background || {};
  const set = (prop, value) => onChange({ [prop]: value }, `bg-${prop}`);
  const reset = () => onChange({ brightness: 1, contrast: 1, saturation: 1, blur: 0, flip_h: false }, null);
  return (
    <div className="flex flex-col gap-2.5" data-testid="bg-adjust">
      <div className="flex items-center justify-between">
        <p className={EYEBROW}>Adjust background</p>
        {hasBackgroundAdjust(bg) ? (
          <button type="button" onClick={reset} className={cn('h-7 px-2.5 rounded-full text-xs font-extrabold flex items-center gap-1 hover:bg-cream', FOCUS_RING)}>
            <RotateCcw className="h-3.5 w-3.5" aria-hidden="true" /> Reset
          </button>
        ) : null}
      </div>
      <SliderRow label="Brightness" value={bg.brightness ?? 1} min={0.3} max={1.7} step={0.02} onChange={(v) => set('brightness', v)} format={pct} testId="bg-brightness" />
      <SliderRow label="Contrast" value={bg.contrast ?? 1} min={0.3} max={1.7} step={0.02} onChange={(v) => set('contrast', v)} format={pct} />
      <SliderRow label="Colour strength" value={bg.saturation ?? 1} min={0} max={2} step={0.02} onChange={(v) => set('saturation', v)} format={pct} />
      <SliderRow label="Soft focus (blur)" value={bg.blur ?? 0} min={0} max={12} step={0.5} onChange={(v) => set('blur', v)} format={(v) => `${v}px`} />
      <button
        type="button"
        onClick={() => onChange({ flip_h: !bg.flip_h }, null)}
        aria-pressed={Boolean(bg.flip_h)}
        className={cn(
          'h-9 rounded-full border text-[13px] font-bold flex items-center justify-center gap-2',
          bg.flip_h ? 'bg-ink text-paper border-ink' : 'border-[#DCD6C8] hover:bg-cream',
          FOCUS_RING
        )}
      >
        <FlipHorizontal2 className="h-4 w-4" aria-hidden="true" /> Mirror the design
      </button>
    </div>
  );
};

export default BackgroundAdjustControls;
